import Vue from 'vue'
import Router from 'vue-router'
import LoginPage from '@/pages/LoginPage'
import MainPage from '@/pages/MainPage'
import Map from '@/pages/Map'

Vue.use(Router)

export default new Router({
    mode: "history",
    routes: [
        {component:Map, path: '/rsamap'},
        {component:LoginPage, path: '/login'},
        {component:LoginPage, path: '/registerPassword/*'},
        {component:LoginPage, path: '/updatePassword/*'},

        {component:MainPage, path: '/'},
        {component:MainPage, path: "/stolen-password-direct-client"},
        {component:MainPage, path: "/stolen-password-direct-employee"},
        {component:MainPage, path: "/stolen-password-3rd-party"},
        {component:MainPage, path: "/targeted-malware"},
        {component:MainPage, path: "/targeted-phishing-site"},
        {component:MainPage, path: "/targeted-phishing-email"},
        {component:MainPage, path: "/malware-hosting"},
        {component:MainPage, path: "/deceptive-phishing-hosting"},
        {component:MainPage, path: "/cc-hosting"},
        {component:MainPage, path: "/phishing-received"},
        {component:MainPage, path: "/botnet-member"},
        {component:MainPage, path: "/targeted-software"},
        {component:MainPage, path: "/spam-sender"},
        {component:MainPage, path: "/drop-sites"},
        {component:MainPage, path: "/known-compromised-hostile-servers"},
        {component:MainPage, path: "/pua-hosting"},
        {component:MainPage, path: "/threat-score"},

        {component:MainPage, path: "/global-targeted-malware"},
        {component:MainPage, path: "/global-targeted-phishing-site"},
        {component:MainPage, path: "/global-targeted-phishing-email"},
        {component:MainPage, path: "/global-malware-hosting"},
        {component:MainPage, path: "/global-deceptive-phishing-hosting"},
        {component:MainPage, path: "/global-cc-hosting"},
        {component:MainPage, path: "/global-phishing-received"},
        {component:MainPage, path: "/global-botnet-member"},
        {component:MainPage, path: "/global-targeted-software"},
        {component:MainPage, path: "/global-spam-sender"},
        {component:MainPage, path: "/global-drop-sites"},
        {component:MainPage, path: "/global-known-compromised-hostile-servers"},
        {component:MainPage, path: "/global-pua-hosting"},

        {component:MainPage, path: "/partner-stolen-password-direct-client"},
        {component:MainPage, path: "/partner-stolen-password-direct-employee"},
        {component:MainPage, path: "/partner-stolen-password-3rd-party"},
        {component:MainPage, path: "/partner-targeted-malware"},
        {component:MainPage, path: "/partner-targeted-phishing-site"},
        {component:MainPage, path: "/partner-targeted-phishing-email"},
        {component:MainPage, path: "/partner-malware-hosting"},
        {component:MainPage, path: "/partner-deceptive-phishing-hosting"},
        {component:MainPage, path: "/partner-cc-hosting"},
        {component:MainPage, path: "/partner-phishing-received"},
        {component:MainPage, path: "/partner-botnet-member"},
        {component:MainPage, path: "/partner-targeted-software"},
        {component:MainPage, path: "/partner-spam-sender"},
        {component:MainPage, path: "/partner-drop-sites"},
        {component:MainPage, path: "/partner-known-compromised-hostile-servers"},
        {component:MainPage, path: "/partner-pua-hosting"},

        {component:MainPage, path: "/industry-targeted-malware"},
        {component:MainPage, path: "/industry-targeted-phishing-site"},
        {component:MainPage, path: "/industry-targeted-phishing-email"},
        {component:MainPage, path: "/industry-malware-hosting"},
        {component:MainPage, path: "/industry-deceptive-phishing-hosting"},
        {component:MainPage, path: "/industry-cc-hosting"},
        {component:MainPage, path: "/industry-phishing-received"},
        {component:MainPage, path: "/industry-botnet-member"},
        {component:MainPage, path: "/industry-targeted-software"},
        {component:MainPage, path: "/industry-spam-sender"},
        {component:MainPage, path: "/industry-drop-sites"},
        {component:MainPage, path: "/industry-known-compromised-hostile-servers"},
        {component:MainPage, path: "/industry-pua-hosting"},

        {component:MainPage, path: "/settings"},
        {component:MainPage, path: "/search-results"},
        { path: '*' , redirect : "/"}
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js